import React from 'react';
import {
  useRouteMatch,
} from 'react-router-dom';

import PortalWrapper from './PortalWrapper';

const Portal = () => {
  const { path } = useRouteMatch();

  return (
    <PortalWrapper path={path} />
  );
};

export default Portal;
